import { Box,Circle,Text } from "@chakra-ui/react";
import { ReactComponent as CoursesIcon } from '../../svg/book.svg'
import { ReactComponent as Hourglass } from '../../svg/hourglass.svg'
import { ReactComponent as LiveSession } from '../../svg/signal.svg'
import { ReactComponent as Users } from '../../svg/group-of-two.svg'
import { ReactComponent as Participants } from '../../svg/group-of-three.svg'
import { ReactComponent as Announcements } from '../../svg/bullhorn.svg'
import { ReactComponent as Schedule } from '../../svg/schedule.svg';
import { ReactComponent as Calendar } from '../../svg/calendar-admin.svg';
import { ReactComponent as Courses } from "../../svg/book.svg";

export default function ItemsList({ items }) {
    return (
       <Box
            w='100%'
            d='flex'
            flexDir='column'
            mb='1.5rem'
        >
            

            <Box
                w='100%'
                d='flex'
                justifyContent='space-between'
                flexWrap='wrap'
                style={{ gap: '0.5rem' }}
            >

                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#3A7DFD1A' mr='1rem'>
                        <Box
                            d='flex'
                            width='24px'
                            height='24px'
                            justifyContent='space-between'
                            alignItems='center'
                            flexWrap='wrap'
                        >
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                border='1px solid #3A7DFD'
                            ></Box>
                        </Box>
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of tutors registered
                        </Text>
                        
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >{items.no_of_tutors}
                                </Text>
                        
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#FD5F3A1A' mr='1rem'>
                        <CoursesIcon width='25px' height='25px' fill='#fd5f3a' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of Pending tutors
                        </Text>
                        
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >{items.pending_tutors}
                                </Text>
                        
                    </Box>
                </Box>

                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#42C9781A' mr='1rem'>
                        <Hourglass width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of approved tutors
                        </Text>
                            <Text
                                fontSize='24px'
                                fontWeight='800'
                                color='#000000'
                            > {items.approved_tutors}
                               
                            </Text>
                        
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#00DBDB1A' mr='1rem'>
                        <LiveSession width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of declined tutors
                        </Text>
                        
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.declined_tutors}
                                </Text>
                        
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#FFC7001A' mr='1rem'>
                        <Users width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of registered students
                        </Text>
                        
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                > {items.no_of_students}
                                </Text>
                        
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Participants width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of approval pending students
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.pending_students}
                                </Text>
                        
                    </Box>
                </Box>
                 <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Participants width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of approved students
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.approved_students}
                                </Text>
                        
                    </Box>
                </Box>
                 <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Participants width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of declined students
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.declined_students}
                                </Text>
                        
                    </Box>
                </Box>
                 <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Calendar width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of holidays
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.no_of_holidays}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Courses width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of library items
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.no_of_library_items}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Announcements width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of announcements
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.no_of_announcements}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Announcements width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of announcements for tutor
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.no_of_announcement_for_tutor}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Announcements width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of announcement for students
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.no_of_announcement_for_student}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Schedule width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of class schedules
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.no_of_class_schedules}
                                </Text>
                        
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Schedule width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No. of exam schedules
                        </Text>
                        
                                <Text
                                    fontSize='20px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {items.no_of_exam_schedules}
                                </Text>
                        
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}